import {
  PageBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { agentAdminPermission } from '@platform/plugin-platform-common';
import { AgentStatusIcon } from './AgentStatusIcon';
import { rootRouteRef } from './routes';

/**
 * La gestion des agents Kubernetes enregistrés, extraite de `legacyRoot.tsx`
 * (phase 4c).
 *
 * Titre et icône de l'entrée de menu REPRIS DE `navSections.ts` : elle
 * s'appelle « Clusters » et pas « agents », pour ne pas confondre le worker
 * Kubernetes avec les agents IA. L'icône porte la pastille d'état de
 * l'agent (`AgentStatusIcon`) : changement visible assumé, elle n'est plus une
 * ligne au-dessus de l'entrée.
 *
 * Changement visible assumé (décision 9 de la spec) : l'entrée n'est plus
 * masquée aux utilisateurs sans `agentAdminPermission`. Ils la voient dans
 * « Gouvernance », et la page leur refuse l'accès.
 */
const agentAdminPage = PageBlueprint.make({
  params: {
    path: '/admin/agents',
    routeRef: rootRouteRef,
    title: 'Clusters',
    icon: <AgentStatusIcon />,
    noHeader: true,
    loader: () =>
      import('./components/AgentAdminPage').then(m => (
        <RequirePermission permission={agentAdminPermission}>
          <m.AgentAdminPage />
        </RequirePermission>
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'agent-router',
  extensions: [agentAdminPage],
});
